import { Field } from 'formik';
import { EmployeePickerField } from 'features/user/user-picker/employee-picker';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from './base-url-params-filter';

type SubordinatesParamsFilterProps = BaseUrlParamsFilterProps & {
  managerId?: number | null;
};

export const SubordinatesParamsFilter = ({
  queryParamName,
  label = 'Сотрудник',
  size = 'medium',
  managerId = null,
}: SubordinatesParamsFilterProps) => (
  <BaseUrlParamsFilter queryParamName={queryParamName}>
    <Field
      fullWidth
      name={queryParamName}
      label={label}
      clearable
      size={size}
      managerId={managerId}
      component={EmployeePickerField}
    />
  </BaseUrlParamsFilter>
);
